unit View.Fs_Prod_SubCategorias.List;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, Math,

  WEBLib.StdCtrls, Web, JS, WEBLib.Lists,

  App.Types, WEBLib.Controls, WEBLib.Grids, Data.DB,
  XData.Web.Dataset, WEBLib.DBCtrls, WEBLib.DB, WEBLib.ExtCtrls,

  XData.Web.JsonDataset,

  Grid.Plugins,
  Crud.Utils, UConstantes, System.StrUtils, UUtils, UWeb.Enum,
  UPersonalizacao_Tabela.Interfaces, UPersonalizacao_Tabela;

type
  TFViewFs_Prod_SubCategoriasList = class(TForm)
    btNew: TButton;
    Fs_Prod_SubCategoriasDataset: TXDataWebDataSet;
    Fs_Prod_SubCategoriasDatasetid: TIntegerField;
    Fs_Prod_SubCategoriasDatasetnome: TStringField;
    Fs_Prod_SubCategoriasDatasetexcluido: TBooleanField;
    Fs_Prod_SubCategoriasDatasetinclusao: TDateTimeField;
    Fs_Prod_SubCategoriasDatasetalteracao: TDateTimeField;
    Fs_Prod_SubCategoriasDatasetexclusao: TDateTimeField;
    WebDBTableControl1: TDBTableControl;
    WebDataSource: TDataSource;
    cbPageSize: TComboBox;
    edSearch: TEdit;
    lbPaginationInfo: TLabel;
    lcPaginator: TListControl;
    tmrConsulta: TTimer;
    procedure WebFormCreate(Sender: TObject);
    procedure btNewClick(Sender: TObject);
    procedure WebDBTableControl1GetCellChildren(Sender: TObject; ACol,
      ARow: Integer; AField: TField; AValue: string; AElement: TJSHTMLElementRecord);
    procedure cbPageSizeChange(Sender: TObject);
    procedure tmrConsultaTimer(Sender: TObject);
    procedure edSearchKeyDown(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure edSearchKeyUp(Sender: TObject; var Key: Word; Shift: TShiftState);
    procedure WebDBTableControl1GetCellClass(Sender: TObject; ACol,
      ARow: Integer; AField: TField; AValue: string; var AClassName: string);
    procedure WebDBTableControl1GetCellData(Sender: TObject; ACol,
      ARow: Integer; AField: TField; var AValue: string);
    procedure WebFormShow(Sender: TObject);
  private
    FEditProc: TEditProc;
    FGridPlugin: TGridPlugin;
    FPersonalizacaoTabela: IPersonalizacao_Tabela;

  public
    class function CreateForm(AElementID: string; AShowEditProc: TEditProc): TForm;
  protected procedure LoadDFMValues; override; end;

var
  FViewFs_Prod_SubCategoriasList: TFViewFs_Prod_SubCategoriasList;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewFs_Prod_SubCategoriasList }

procedure TFViewFs_Prod_SubCategoriasList.cbPageSizeChange(Sender: TObject);
begin
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text), True);
end;

class function TFViewFs_Prod_SubCategoriasList.CreateForm(AElementID: string;
  AShowEditProc: TEditProc): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewFs_Prod_SubCategoriasList(AForm).FEditProc := AShowEditProc;
  end;

begin
  Application.CreateForm(TFViewFs_Prod_SubCategoriasList, AElementID, Result, @AfterCreate);
end;

procedure TFViewFs_Prod_SubCategoriasList.edSearchKeyDown(Sender: TObject;
  var Key: Word; Shift: TShiftState);
begin
  tmrConsulta.Enabled := False;

  if Key = 13 then
  begin
    FGridPlugin.SetFilterText(edSearch.Text, True);
  end;
end;

procedure TFViewFs_Prod_SubCategoriasList.edSearchKeyUp(Sender: TObject;
  var Key: Word; Shift: TShiftState);
begin
  tmrConsulta.Interval := FTimerConsulta;
  tmrConsulta.Enabled := True;
end;

procedure TFViewFs_Prod_SubCategoriasList.tmrConsultaTimer(Sender: TObject);
begin
  FGridPlugin.SetFilterText(edSearch.Text, True);

  tmrConsulta.Enabled := False;
  tmrConsulta.Interval := FTimerConsulta;
end;

procedure TFViewFs_Prod_SubCategoriasList.btNewClick(Sender: TObject);
begin
  FEditProc( nil );
end;

procedure TFViewFs_Prod_SubCategoriasList.WebDBTableControl1GetCellChildren(Sender: TObject;
  ACol, ARow: Integer; AField: TField; AValue: string;
  AElement: TJSHTMLElementRecord);
var
  RecordId: JSValue;

  procedure EditButtonClick(Sender: TObject);
  begin
    FEditProc(RecordId);
  end;

var
  Button: TButton;
begin
  if ARow = 0 then
    Exit;

  if WebDBTableControl1.Columns[ACol].Title = 'Ação' then
  begin
    RecordId := TCrudUtils.GetIdFromObject(
      Fs_Prod_SubCategoriasDataset.Connection.Model.DefaultSchema.FindEntityType(Fs_Prod_SubCategoriasDataset.EntitySetName),
      Fs_Prod_SubCategoriasDataset.CurrentData
    );

    Button := TButton.Create(nil);
    Button.Caption := '<i class="fa fa-edit"></i>';
    Button.OnClick := @EditButtonClick;
    Button.ElementClassName := 'btn btn-link btn-primary btn-lg';
    Button.ParentElement := AElement.element;
    Button.WidthStyle := TSizeStyle.ssAuto;
    Button.HeightStyle := TSizeStyle.ssAuto;
    Button.ElementHandle.setAttribute('data-test', 'btn_editar_subcategoria');
  end;
end;

procedure TFViewFs_Prod_SubCategoriasList.WebDBTableControl1GetCellClass(
  Sender: TObject; ACol, ARow: Integer; AField: TField; AValue: string;
  var AClassName: string);
begin
  if ARow = 0 then
    AClassName := 'text-center'
  else
  begin
    case IndexStr(WebDBTableControl1.Columns[ACol].DataField, ['nome']) of
      0 : AClassName := 'text-start';
      else AClassName := 'text-center';
    end;
  end;
end;

procedure TFViewFs_Prod_SubCategoriasList.WebDBTableControl1GetCellData(
  Sender: TObject; ACol, ARow: Integer; AField: TField; var AValue: string);
begin
  if ARow > 0 then
  begin
    case IndexStr(WebDBTableControl1.Columns[ACol].DataField, ['excluido']) of
      0:
      begin
        if AValue = 'True' then
          AValue := '<i class="fas fa-check text-success"><i>'
        else if AValue = 'False' then
          AValue := '<i class="fas fa-times text-danger"><i>'
      end;
    end;
  end;
end;

procedure TFViewFs_Prod_SubCategoriasList.WebFormCreate(Sender: TObject);
begin
  FPersonalizacaoTabela := TPersonalizacao_Tabela.Create(Self.Name, WebDBTableControl1,
    cbPageSize);

  TUtils.SetValorDicionarioClasses('fs_prod_subcategorias', 'active');
  TUtils.SetValorDicionarioClasses('fs_produtos_collapse', 'show');
  TUtils.SetValorDicionarioClasses('menu_fs_produtos', 'active');
  TUtils.SetPaginaSelecionada;

  FGridPlugin := TGridPlugin.Create(
    WebDBTableControl1,
    Fs_Prod_SubCategoriasDataset,
    lcPaginator,
    lbPaginationInfo
  );

  FGridPlugin.FDatasetPlugin.FOrderByPadrao := 'id desc';
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text));
  FGridPlugin.SetFilterText(edSearch.Text);
  FGridPlugin.Load;
end;

procedure TFViewFs_Prod_SubCategoriasList.WebFormShow(Sender: TObject);
begin
  if not TUtils.PossuiPermissao(Fs_Prod_SubCategoriasDataset.EntitySetName.ToLower, TTipoPermissao.INSERIR) then
    btNew.Enabled := False;
end;

procedure TFViewFs_Prod_SubCategoriasList.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lbPaginationInfo := TLabel.Create('view.fs_prod_subcategorias.list.pagination.info');
  btNew := TButton.Create('view.fs_prod_subcategorias.list.newbutton');
  WebDBTableControl1 := TDBTableControl.Create('view.fs_prod_subcategorias.list.table');
  cbPageSize := TComboBox.Create('view.fs_prod_subcategorias.list.cbPageSize');
  edSearch := TEdit.Create('view.fs_prod_subcategorias.list.search');
  lcPaginator := TListControl.Create('view.fs_prod_subcategorias.list.pagination');
  Fs_Prod_SubCategoriasDataset := TXDataWebDataSet.Create(Self);
  Fs_Prod_SubCategoriasDatasetid := TIntegerField.Create(Self);
  Fs_Prod_SubCategoriasDatasetnome := TStringField.Create(Self);
  Fs_Prod_SubCategoriasDatasetexcluido := TBooleanField.Create(Self);
  Fs_Prod_SubCategoriasDatasetinclusao := TDateTimeField.Create(Self);
  Fs_Prod_SubCategoriasDatasetalteracao := TDateTimeField.Create(Self);
  Fs_Prod_SubCategoriasDatasetexclusao := TDateTimeField.Create(Self);
  WebDataSource := TDataSource.Create(Self);
  tmrConsulta := TTimer.Create(Self);

  lbPaginationInfo.BeforeLoadDFMValues;
  btNew.BeforeLoadDFMValues;
  WebDBTableControl1.BeforeLoadDFMValues;
  cbPageSize.BeforeLoadDFMValues;
  edSearch.BeforeLoadDFMValues;
  lcPaginator.BeforeLoadDFMValues;
  Fs_Prod_SubCategoriasDataset.BeforeLoadDFMValues;
  Fs_Prod_SubCategoriasDatasetid.BeforeLoadDFMValues;
  Fs_Prod_SubCategoriasDatasetnome.BeforeLoadDFMValues;
  Fs_Prod_SubCategoriasDatasetexcluido.BeforeLoadDFMValues;
  Fs_Prod_SubCategoriasDatasetinclusao.BeforeLoadDFMValues;
  Fs_Prod_SubCategoriasDatasetalteracao.BeforeLoadDFMValues;
  Fs_Prod_SubCategoriasDatasetexclusao.BeforeLoadDFMValues;
  WebDataSource.BeforeLoadDFMValues;
  tmrConsulta.BeforeLoadDFMValues;
  try
    Name := 'FViewFs_Prod_SubCategoriasList';
    Width := 695;
    Height := 500;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    SetEvent(Self, 'OnShow', 'WebFormShow');
    lbPaginationInfo.SetParentComponent(Self);
    lbPaginationInfo.Name := 'lbPaginationInfo';
    lbPaginationInfo.Left := 8;
    lbPaginationInfo.Top := 376;
    lbPaginationInfo.Width := 141;
    lbPaginationInfo.Height := 13;
    lbPaginationInfo.Caption := 'Showing 1 to 10 of 57 entries';
    lbPaginationInfo.HeightPercent := 100.000000000000000000;
    lbPaginationInfo.WidthPercent := 100.000000000000000000;
    btNew.SetParentComponent(Self);
    btNew.Name := 'btNew';
    btNew.Left := 8;
    btNew.Top := 8;
    btNew.Width := 50;
    btNew.Height := 25;
    btNew.Caption := 'New';
    btNew.HeightPercent := 100.000000000000000000;
    btNew.WidthPercent := 100.000000000000000000;
    SetEvent(btNew, Self, 'OnClick', 'btNewClick');
    WebDBTableControl1.SetParentComponent(Self);
    WebDBTableControl1.Name := 'WebDBTableControl1';
    WebDBTableControl1.Left := 8;
    WebDBTableControl1.Top := 94;
    WebDBTableControl1.Width := 521;
    WebDBTableControl1.Height := 265;
    WebDBTableControl1.ElementClassName := 'table-responsive';
    WebDBTableControl1.BorderColor := clSilver;
    WebDBTableControl1.ColHeader := False;
    WebDBTableControl1.ElementTableClassName := 'table table-striped table-bordered table-hover dataTable';
    SetEvent(WebDBTableControl1, Self, 'OnGetCellData', 'WebDBTableControl1GetCellData');
    SetEvent(WebDBTableControl1, Self, 'OnGetCellChildren', 'WebDBTableControl1GetCellChildren');
    SetEvent(WebDBTableControl1, Self, 'OnGetCellClass', 'WebDBTableControl1GetCellClass');
    WebDBTableControl1.Columns.Clear;
    with WebDBTableControl1.Columns.Add do
    begin
      Title := 'A'#231#227'o';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'id';
      Title := 'C'#243'd.';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'nome';
      Title := 'nome';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'excluido';
      Title := 'Exclu'#237'do';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'inclusao';
      Title := 'Inclus'#227'o';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'alteracao';
      Title := 'Altera'#231#227'o';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'exclusao';
      Title := 'Exclus'#227'o';
    end;
    WebDBTableControl1.DataSource := WebDataSource;
    cbPageSize.SetParentComponent(Self);
    cbPageSize.Name := 'cbPageSize';
    cbPageSize.Left := 8;
    cbPageSize.Top := 67;
    cbPageSize.Width := 81;
    cbPageSize.Height := 21;
    cbPageSize.HeightPercent := 100.000000000000000000;
    cbPageSize.TabOrder := 2;
    cbPageSize.Text := '10';
    cbPageSize.WidthPercent := 100.000000000000000000;
    SetEvent(cbPageSize, Self, 'OnChange', 'cbPageSizeChange');
    cbPageSize.ItemIndex := 0;
    cbPageSize.Items.BeginUpdate;
    try
      cbPageSize.Items.Clear;
      cbPageSize.Items.Add('10');
      cbPageSize.Items.Add('25');
      cbPageSize.Items.Add('50');
      cbPageSize.Items.Add('100');
    finally
      cbPageSize.Items.EndUpdate;
    end;
    edSearch.SetParentComponent(Self);
    edSearch.Name := 'edSearch';
    edSearch.Left := 408;
    edSearch.Top := 67;
    edSearch.Width := 121;
    edSearch.Height := 21;
    edSearch.HeightPercent := 100.000000000000000000;
    edSearch.TabOrder := 3;
    edSearch.WidthPercent := 100.000000000000000000;
    SetEvent(edSearch, Self, 'OnKeyDown', 'edSearchKeyDown');
    SetEvent(edSearch, Self, 'OnKeyUp', 'edSearchKeyUp');
    lcPaginator.SetParentComponent(Self);
    lcPaginator.Name := 'lcPaginator';
    lcPaginator.Left := 240;
    lcPaginator.Top := 365;
    lcPaginator.Width := 289;
    lcPaginator.Height := 25;
    lcPaginator.HeightPercent := 100.000000000000000000;
    lcPaginator.WidthPercent := 100.000000000000000000;
    lcPaginator.DefaultItemClassName := 'page-item';
    lcPaginator.DefaultItemLinkClassName := 'page-link';
    lcPaginator.ElementListClassName := 'pagination';
    lcPaginator.Style := lsPagination;
    Fs_Prod_SubCategoriasDataset.SetParentComponent(Self);
    Fs_Prod_SubCategoriasDataset.Name := 'Fs_Prod_SubCategoriasDataset';
    Fs_Prod_SubCategoriasDataset.EntitySetName := 'Fs_Prod_SubCategorias';
    Fs_Prod_SubCategoriasDataset.Connection := DMConnection.ApiConnection;
    Fs_Prod_SubCategoriasDataset.Left := 72;
    Fs_Prod_SubCategoriasDataset.Top := 144;
    Fs_Prod_SubCategoriasDatasetid.SetParentComponent(Fs_Prod_SubCategoriasDataset);
    Fs_Prod_SubCategoriasDatasetid.Name := 'Fs_Prod_SubCategoriasDatasetid';
    Fs_Prod_SubCategoriasDatasetid.FieldName := 'id';
    Fs_Prod_SubCategoriasDatasetid.Required := True;
    Fs_Prod_SubCategoriasDatasetnome.SetParentComponent(Fs_Prod_SubCategoriasDataset);
    Fs_Prod_SubCategoriasDatasetnome.Name := 'Fs_Prod_SubCategoriasDatasetnome';
    Fs_Prod_SubCategoriasDatasetnome.FieldName := 'nome';
    Fs_Prod_SubCategoriasDatasetnome.Required := True;
    Fs_Prod_SubCategoriasDatasetnome.Size := 255;
    Fs_Prod_SubCategoriasDatasetexcluido.SetParentComponent(Fs_Prod_SubCategoriasDataset);
    Fs_Prod_SubCategoriasDatasetexcluido.Name := 'Fs_Prod_SubCategoriasDatasetexcluido';
    Fs_Prod_SubCategoriasDatasetexcluido.FieldName := 'excluido';
    Fs_Prod_SubCategoriasDatasetinclusao.SetParentComponent(Fs_Prod_SubCategoriasDataset);
    Fs_Prod_SubCategoriasDatasetinclusao.Name := 'Fs_Prod_SubCategoriasDatasetinclusao';
    Fs_Prod_SubCategoriasDatasetinclusao.FieldName := 'inclusao';
    Fs_Prod_SubCategoriasDatasetinclusao.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    Fs_Prod_SubCategoriasDatasetalteracao.SetParentComponent(Fs_Prod_SubCategoriasDataset);
    Fs_Prod_SubCategoriasDatasetalteracao.Name := 'Fs_Prod_SubCategoriasDatasetalteracao';
    Fs_Prod_SubCategoriasDatasetalteracao.FieldName := 'alteracao';
    Fs_Prod_SubCategoriasDatasetalteracao.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    Fs_Prod_SubCategoriasDatasetexclusao.SetParentComponent(Fs_Prod_SubCategoriasDataset);
    Fs_Prod_SubCategoriasDatasetexclusao.Name := 'Fs_Prod_SubCategoriasDatasetexclusao';
    Fs_Prod_SubCategoriasDatasetexclusao.FieldName := 'exclusao';
    Fs_Prod_SubCategoriasDatasetexclusao.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    WebDataSource.SetParentComponent(Self);
    WebDataSource.Name := 'WebDataSource';
    WebDataSource.DataSet := Fs_Prod_SubCategoriasDataset;
    WebDataSource.Left := 72;
    WebDataSource.Top := 200;
    tmrConsulta.SetParentComponent(Self);
    tmrConsulta.Name := 'tmrConsulta';
    tmrConsulta.Enabled := False;
    SetEvent(tmrConsulta, Self, 'OnTimer', 'tmrConsultaTimer');
    tmrConsulta.Left := 392;
    tmrConsulta.Top := 232;
  finally
    lbPaginationInfo.AfterLoadDFMValues;
    btNew.AfterLoadDFMValues;
    WebDBTableControl1.AfterLoadDFMValues;
    cbPageSize.AfterLoadDFMValues;
    edSearch.AfterLoadDFMValues;
    lcPaginator.AfterLoadDFMValues;
    Fs_Prod_SubCategoriasDataset.AfterLoadDFMValues;
    Fs_Prod_SubCategoriasDatasetid.AfterLoadDFMValues;
    Fs_Prod_SubCategoriasDatasetnome.AfterLoadDFMValues;
    Fs_Prod_SubCategoriasDatasetexcluido.AfterLoadDFMValues;
    Fs_Prod_SubCategoriasDatasetinclusao.AfterLoadDFMValues;
    Fs_Prod_SubCategoriasDatasetalteracao.AfterLoadDFMValues;
    Fs_Prod_SubCategoriasDatasetexclusao.AfterLoadDFMValues;
    WebDataSource.AfterLoadDFMValues;
    tmrConsulta.AfterLoadDFMValues;
  end;
end;

end.
